import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

lessRequire('modules/offers/components/promo-gallery/categories.less');

const propTypes = {
	categories: PropTypes.array,
	currentCategory: PropTypes.string,
	choose: PropTypes.func,
	onSelect: PropTypes.func
};

const Categories = ({
	categories,
	currentCategory,
	onSelect
}) => (
	<div className="promo-categories">
		{ categories.map(category => (
			<button
				key={category.id}
				onClick={() => onSelect(category.id)}
				className={cn('font-proxima-nova-regular item', category.id === currentCategory && 'item--active')}>
				{category.text}
			</button>
		)) }

	</div>
);

Categories.propTypes = propTypes;
export default Categories;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/promo-gallery/categories.js